module.exports = "../../static/img/home.c6eef3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iconActive/home.png
// module id = 6OLa
// module chunks = 9